import {
  Button,
  Col,
  Form,
  Progress,
  Row,
  Spin,
  Checkbox,
  Modal,
  Grid,
  Switch,
  Tooltip,
  Flex,
  Divider,
} from "antd";
import React, { useEffect, useState } from "react";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import CarbonUser from "../../../../../assets/webimage/CarbonUser.svg?react";
import { rules } from "./Rules";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../store/app";
import "../../../../../assets/styles/CustomStyles/cutomStyles.css";
import "../../Style/userProfile.less";
import {
  fetchRaceList,
  fetchVeteranList,
  masterLov,
  setRace,
  setveteran,
  updateProfile,
  trialUserUpgrade,
  userExamFlowReset,
  setUserSpecialFlag,
} from "../Utils/slice";
import { assignErrorToInput } from "../../../../../store/api";
import { CONSTANT } from "../../../../../config/Constant";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import { UserProfileBreadcrumb } from "../../../../../config/BreadcrumbConfig";
import dayjs from "dayjs";
import {
  mobilePattern,
  setAddClassInputAnimation,
  stringDecryption,
} from "../../../../../config/Global";
import { useNavigate } from "react-router-dom";
import CommonModal from "../../../../../components/Modals/CommonModal";
import { deleteAccount, setUserOptions } from "../../../../../store/AuthSlice";

import { rules as changePasswordRules } from "../ProfileChangePassword/Rules";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { DownloadOutlined } from "@ant-design/icons";
import { setResetInputAnimation, getCookie, clearCookie } from "../../../../../config/Global";
import ProfileChangePassword from "../ProfileChangePassword/ProfileChangePassword";
import { setHasAccessCodeStatus, setHasProfileUpdated } from "../../../../../store/CommonSlice";


const { useBreakpoint } = Grid;
/**
 * Renders form component to update the User Profile.
 *
 * @return {JSX.Element} The rendered form component.
 */
const UserProfile = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();
  const { userDetail, mapScriptLoaded } = useSelector(
    (state: RootState) => state.AUTH
  );
  const raceData = useSelector((state: RootState) => state.WEBPROFILE.race);
  const veteranData = useSelector(
    (state: RootState) => state.WEBPROFILE.veteran
  );
  const screens = useBreakpoint();
  const [latLng, setLatLng] = useState<{ lat: number; lng: number }>();
  const [genderCheck, setGenderCheck] = useState("0");
  const [disabilitiesCheck, setDisabilitiesCheck] = useState("0");
  const [veteranStatusCheck, setVeteranStatusCheck] = useState("0");
  const [houseHoldCheck, setHouseHoldCheck] = useState("0");
  const [EthnicityCheck, setEthnicityCheck] = useState("0");
  const profileProgress = useSelector(
    (state: RootState) => state.AUTH.profileProgress
  );
  const [disabilityStatus, setDisabilityStatus] = useState<any>();
  const [houseHold, setHouseHold] = useState<any>();
  const [gender, setGender] = useState<any>();
  const [educationLevel, setEducationLevel] = useState<any>([]);
  const [yearsOfExperience, setYearsOfExperience] = useState<any>([]);

  const [save, setSave] = useState<boolean>(false);
  const [deleteAccoutnModal, setDeleteAccountModal] = useState<boolean>(false);
  const [eduExpConfirmModal, setEduExpConfirmModal] = useState<boolean>(false);
  const initialStoreData: any = useSelector(
    (state: RootState) => state.AUTH.initialData
  );

  // code for fetching state detail from zip code : start
  const [result, setResult] = useState<any>();
  const [pinCode, setPinCode] = useState<any>();
  const [stateDetail, setStateDetail] = useState<any>([]);
  const [selectOk, setSelectOk] = useState<number>(0);
  const [list, setList] = useState<any>();
  const [pinCodeFinal, state] = stateDetail;
  const [rememberToggle, setRememberToggle] = useState<boolean>(false);
  const [isPlacePredictionsLoading, setIsPlacePredictionsLoading] =
    useState(false);


  const getCityName = (result: any) => {
    // 1. Check if results exist and have at least one entry
    if (!result) return '';

    // 2. Get the address components from the first (most accurate) result
    const components = result.address_components;

    // 3. Find the component where the types array includes "locality"
    // Fallbacks: "sublocality_level_1" (for NYC) or "postal_town" (for UK)
    const cityComponent = components.find((c: any) =>
      c.types.includes("locality") ||
      c.types.includes("sublocality_level_1") ||
      c.types.includes("postal_town")
    );

    // 4. Return the long_name (e.g., "New York") or null
    return cityComponent ? cityComponent.long_name : '';
  };


  /**
 * Extracts Latitude and Longitude from a Google Maps Geocode response.
 * Works with both the JS SDK and direct JSON API responses.
 */
  const getLatLng = (result: any) => {
    if (!result || !result.geometry) {
      return null;
    }

    const location = result.geometry.location;

    // Handle both SDK function calls and raw JSON properties
    const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
    const lng = typeof location.lng === 'function' ? location.lng() : location.lng;

    return {
      lat: Number(lat),
      lng: Number(lng)
    };
  };

  useEffect(() => {
    const onlyContainsNumbers = (pinCode: any) => /^\d+$/.test(pinCode);
    // setAddClassInputAnimation();

    if (onlyContainsNumbers(pinCode)) {
      setIsPlacePredictionsLoading(true);
      const geocoder: google.maps.Geocoder | any = new google.maps.Geocoder();
      if (google.maps) {
        const geoCode: any = (request: google.maps.GeocoderRequest): void => {
          geocoder.geocode(request, (results: any, status: any) => {
            if (status === "OK" && results) {
              setResult({ results });
            } else {
              console.log("GeoCode not found");
            }
          });
        };
        geoCode({ address: pinCode });
      }
    }
  }, [pinCode]);

  useEffect(() => {
    if (Array.isArray(result?.results)) {
      const mappedList = result?.results.map((data: any, index: number) => ({
        id: index + 1,
        name: data.formatted_address,
      }));
      setList(mappedList);
      setIsPlacePredictionsLoading(false);
    }
  }, [result]);

  useEffect(() => {
    if (selectOk !== 0 && result.results) {
      const details = result?.results[selectOk - 1]?.address_components;
      setStateDetail([
        details?.[0]?.long_name,
        details?.[details.length - 2]?.long_name,
      ]);
      form.setFieldsValue({ location: details?.[0]?.long_name });
      let city = getCityName(result?.results[selectOk - 1]);
      form.setFieldsValue({ city: (city || '') })

      let locationdata = getLatLng(result?.results[selectOk - 1]);
      setLatLng({
        lat: Number(locationdata?.lat),
        lng: Number(locationdata?.lng),
      });

    } else {
      setStateDetail([]);
    }
  }, [selectOk]);

  // code for fetching state detail from zip code : end

  useEffect(() => {
    const initialData: any = sessionStorage?.getItem("initialData");
    if (initialData) {
      const { disability_status } = JSON.parse(initialData);
      setDisabilityStatus(disability_status);
    }
    if (initialData) {
      const { annual_income, profile_year_of_experience, profile_education_level ,gender} = JSON.parse(initialData);
      setHouseHold(annual_income);
      setYearsOfExperience(profile_year_of_experience);
      setEducationLevel(profile_education_level);
      setGender(gender);
    } else {
      setHouseHold(initialStoreData.annual_income);
      setYearsOfExperience(initialStoreData.profile_year_of_experience);
      setEducationLevel(initialStoreData.profile_education_level);
      setGender(initialStoreData.gender);
    }


    if (userDetail?.location) {
      setPinCode(userDetail?.location);
    }

    if (userDetail?.race_id || userDetail?.race_id==0) {
      dispatch(setRace([userDetail.race]));
      form.setFieldsValue({
        race_id: userDetail?.race_id,
      });
    }
    if (userDetail?.veteran_status_id || userDetail?.veteran_status_id==0) {
      dispatch(setveteran([userDetail?.veteran]));
      form.setFieldsValue({
        veteran_status: userDetail?.veteran_status_id,
      });
    }

    form.setFieldsValue({
      ...userDetail,
      industry:
        typeof userDetail?.industry === "object" &&
          userDetail?.industry !== null
          ? userDetail.industry.name
          : userDetail?.industry,
 
      dob: userDetail?.dob ? dayjs(userDetail?.dob) : "",
      year_of_experience: userDetail?.year_of_experience ? Number(userDetail?.year_of_experience) : null,
      education_level: userDetail?.education_level ? Number(userDetail?.education_level) : null,
    });
    // console.log([userDetail?.education])
    if (userDetail?.disabilities) {
      form.setFieldValue("disabilities", userDetail?.disabilities?.id);
    }
    if (userDetail?.house_hold_income || userDetail?.house_hold_income==0) {
      form.setFieldValue(
        "house_hold_income",
        userDetail?.house_hold_income?.id
      );
    }

    setLatLng({
      lat: Number(userDetail?.latitude),
      lng: Number(userDetail?.longitude),
    });
    if (userDetail?.mobile_no) {
      form.setFieldsValue({ mobile_no: mobilePattern(userDetail?.mobile_no) });
    }
  



    console.log('userDetail', userDetail)


    setRememberToggle(false);
    // let rememberMeVar: any = localStorage.getItem("remember_me");
    let rememberMeVar: any = getCookie("remember_me");
    if (rememberMeVar) {
      rememberMeVar = JSON.parse(stringDecryption(rememberMeVar));
      if (userDetail?.email === rememberMeVar.email) {
        setRememberToggle(true)
      }
    }






  }, [userDetail, setRace, form]);


  useEffect(() => {
    return () => {
      dispatch(setHasAccessCodeStatus(false));
    };
  }, [])


  const get_current_access = userDetail?.purchased && userDetail.purchased == 1;
  const [accessform] = Form.useForm();
  const hasAccessCodeStatus = useSelector((state: RootState) => state.COMMON.hasAccessCodeStatus)
  // const [hasAccessCode, setHasAccessCode] = useState(false)

  const [activeTab, setActiveTab] = useState("Personal Data");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);
  const [showBillingMobileScreen, setShowBillingMobileScreen] = useState(false);


  useEffect(() => {
    if (hasAccessCodeStatus) {
      setActiveTab("Subscription");
    }
  }, [hasAccessCodeStatus])



  useEffect(() => {
    setResetInputAnimation();
    return () => {
      setResetInputAnimation(false);
    };

  }, [activeTab, hasAccessCodeStatus])




  const changeConfimation = (data: any) => {
    console.log('userDetail?.interest_assessment_exam_status', userDetail?.interest_assessment_exam_status)
    console.log('userDetail?.skill_assessment_exam_status', userDetail?.skill_assessment_exam_status)
    console.log('data.education_level', data.education_level)
    console.log('data.year_of_experience', data.year_of_experience)
    if (
      (
        userDetail?.interest_assessment_exam_status == 1 ||
        userDetail?.skill_assessment_exam_status == 1
      ) &&
      (
        data.education_level != userDetail?.education_level ||
        data.year_of_experience != userDetail?.year_of_experience
      )
    ) {
      setEduExpConfirmModal(true);
      return;
    }
    else {
      if (
        data.education_level != userDetail?.education_level ||
        data.year_of_experience != userDetail?.year_of_experience
      ) {
        var specialProfileFlagRequest = {
          user_id: userDetail.id,
          flag: 1,
          type: 2
        }
        dispatch(setUserSpecialFlag(specialProfileFlagRequest))
        dispatch(setHasProfileUpdated(true));
      }
      userProfileUpdate();
    }
  }




  /**
   * Updates the user profile with the given data and navigates to the dashboard page
   * on success and throws an error on failure.
   *
   * @param {any} data - The data to update the user's profile with.
   * @return {void}
   */
  const userProfileUpdate = (resetExam: boolean = false) => {

    const data = form.getFieldsValue();
    setEduExpConfirmModal(false);
    setSave(true);
    (data.location = pinCodeFinal
      ? Number(pinCodeFinal)
      : userDetail?.location),
      (data.state = state ? state : userDetail?.state);
   
    data.dob = dayjs(data.dob).format(CONSTANT.POST_DATE_FORMAT);
    data.latitude = latLng?.lat;
    data.longitude = latLng?.lng;
    // console.log('data',data);
    dispatch(updateProfile(data))
      .then(() => {

        if (resetExam) {
          dispatch(userExamFlowReset(userDetail?.id))
            .then(() => {
              setSave(false);
              navigate("/dashboard");
            });
          return;
        }
        setSave(false);
        navigate("/dashboard");
        return;
      })
      .catch((error: any) => {
        setSave(false);
        assignErrorToInput(form, error?.STATUS);
      });
  };


  const userAccessCodeChange = (data: any) => {
    dispatch(trialUserUpgrade(data))
      .then(() => {
        dispatch(setUserOptions()).then(() =>
          navigate("/dashboard")
        ).catch((e: any) => e)

      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.STATUS);
      });
  }

  const openDeleteAccountModal = () => {
    setDeleteAccountModal(true);
  };

  const closeDeleteAccountModal = () => {
    setDeleteAccountModal(false);
  };

  const deleteAccountBtn = () => {
    dispatch(deleteAccount()).catch((e: any) => e);
  };

  const getVeteranList = () => {
    dispatch(fetchVeteranList()).catch((error: any) =>
      assignErrorToInput(form, error?.STATUS)
    );
  };

  const minDate = dayjs().subtract(13, "years");
  const disableDate = (current: any) => {
    return current && current > minDate;
  };

  // For form validation on change
  const handleChange = () => {
    form.validateFields({ dirty: true });
  };



  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 700);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    }

  }, []);

  const changePasswordHandler = (data: any) => {
    console.log("Change password data:", data);
  };

  const [confirmDeleteChecked, setConfirmDeleteChecked] = useState(false);
  const [billingModalVisible, setBillingModalVisible] = useState(false);

  // Example billing data (replace with real data as needed)
  const billingHistory = [
    {
      plan: "Explorer Plan",
      invoice: "INV-C-2024-5478965",
      date: "May 20,2024",
      amount: "$259.99",
      status: "Paid",
    },
    {
      plan: "Explorer Plan",
      invoice: "INV-C-2023-5478978",
      date: "May 20,2023",
      amount: "$259.99",
      status: "Paid",
    },
    {
      plan: "Explorer Plan",
      invoice: "INV-C-2022-5477789",
      date: "May 20,2022",
      amount: "$259.99",
      status: "Cancelled",
    },
    {
      plan: "Explorer Plan",
      invoice: "INV-C-2021-5474587",
      date: "May 20,2021",
      amount: "$259.99",
      status: "Cancelled",
    },
  ];

  if (showBillingMobileScreen && window.innerWidth <= 700) {
    return (
      <div className="billing-history-mobile-fullscreen">
        <div className="billing-history-mobile-header billing-history-mobile-breadcrumb">
          <span
            className="billing-history-mobile-breadcrumb-link"
            onClick={() => setShowBillingMobileScreen(false)}
            tabIndex={0}
            role="button"
          >
            Subscription
          </span>
          <span className="billing-history-mobile-breadcrumb-sep">{">"}</span>
          <span className="billing-history-mobile-breadcrumb-current">
            Billing Information
          </span>
        </div>
        <div className="billing-history-mobile-list">
          {billingHistory.map((row, idx) => (
            <div
              className={
                "billing-history-mobile-card" +
                (idx % 2 === 0 ? " billing-history-mobile-card-alt" : "")
              }
              key={row.invoice}
            >
              <div className="billing-history-mobile-row">
                <span className="billing-history-mobile-label">
                  Subscription
                </span>
                <span className="billing-history-mobile-value">{row.plan}</span>
              </div>
              <div className="billing-history-mobile-row">
                <span className="billing-history-mobile-label">Invoice</span>
                <span className="billing-history-mobile-value">
                  {row.invoice}
                </span>
              </div>
              <div className="billing-history-mobile-row">
                <span className="billing-history-mobile-label">
                  Billing Date
                </span>
                <span className="billing-history-mobile-value">{row.date}</span>
              </div>
              <div className="billing-history-mobile-row">
                <span className="billing-history-mobile-label">Amount</span>
                <span className="billing-history-mobile-value">
                  {row.amount}
                </span>
              </div>
              <div className="billing-history-mobile-row">
                <span className="billing-history-mobile-label">Status</span>
                <span>
                  {row.status === "Paid" ? (
                    <span className="billing-status billing-status-paid">
                      Paid
                    </span>
                  ) : (
                    <span className="billing-status billing-status-cancelled">
                      Cancelled
                    </span>
                  )}
                </span>
              </div>
              <Button
                className="billing-download-btn billing-download-btn-mobile"
                icon={<DownloadOutlined />}
              >
                Download
              </Button>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const [checkboxRerender, setCheckboxRerender] = useState(0);


  const declineDisability = form.getFieldValue('decline_to_answer_disabilities');
  const declineVeteran = form.getFieldValue('decline_to_answer_veteran_status');
  const getRaceList = () => {
    dispatch(fetchRaceList()).catch((error: any) =>
      assignErrorToInput(form, error?.STATUS)
    );
  };


  const onRememberToggleChange = (value: boolean) => {
    if (!value) {
      // localStorage.removeItem("remember_me");
      clearCookie("remember_me");
      setRememberToggle(false);
    }

  }

  const willing_to_relocate_value = Form.useWatch('willing_to_relocate', form); // Watch a single field


  const education_level_value = Form.useWatch('education_level', form); // Watch a single field
  const year_of_experience = Form.useWatch('year_of_experience', form); // Watch a single field





  console.log("screens", screens)

  return (
    <div className="user-profile-page">
      <div className="container-fluid">
        <div className='breadcrumb has-button'>
          <BreadcrumbComponent
            key={1}
            items={UserProfileBreadcrumb.path}
          />


        </div>

        <div className="profile-tabs-row">
          <div className="profile-tabs">
            {[
              "Personal Data",
              "Change Password",
              "Account Settings",
              "Subscription",
            ].map((tab) => (
              <span
                key={tab}
                className={`profile-tab${activeTab === tab ? " active" : ""}`}
                onClick={() => setActiveTab(tab)}
                tabIndex={0}
                role="button"
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") setActiveTab(tab);
                }}
              >
                {tab}
              </span>
            ))}
          </div>
        </div>
        <>
          {activeTab === "Personal Data" && (
            <div className="profile-card-container">
              <FormBox
                layout="vertical"
                autoComplete="off"
                form={form}
                id="userProfileUpdate"
                onFinish={changeConfimation}
                onChange={handleChange}
                className="userProfile commanDrawer"
              >
                <div className="profile-section-common">
                  <div className="profile-section-header" style={{ marginTop: '0' }}>About You</div>
                  <Row gutter={[0, 24]}>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                      <InputBox.Text
                        name="name"
                        label={<>First name <em>*</em></>}
                        placeholder=''
                        className="ecn-input profile-input"
                        rules={rules.name()}
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                      <InputBox.Text
                        name="last_name"
                        label={<>Last name <em>*</em></>}
                        placeholder=''
                        className="ecn-input profile-input"
                        rules={rules.last_name()}
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                      <InputBox.Text
                        name="email"
                        label={<>Email <em>*</em></>}
                        placeholder=''
                        className="ecn-input profile-input"

                        disabled
                        rules={rules.email()}
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                      <InputBox.Text
                        name="mobile_no"
                        // placeholder="000-000-0000"
                        // label="Mobile No"
                        label={<>Phone number <em>*</em></>}
                        placeholder=''
                        className="ecn-input profile-input"
                        maxLength={20}
                        rules={rules.mobile()}
                        onChange={(e: any) => {
                          if (e.target.value.length > 0) {
                            form.setFieldsValue({
                              mobile_no: mobilePattern(e.target.value),
                            });
                          }
                        }}
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                      <InputBox.DatePicker
                        required
                        name="dob"
                        label={<>Date of birth <em>*</em></>}
                        placeholder=''
                        className="ecn-input profile-input active"
                        allowClear={false}
                        rules={rules.dob()}
                        disabledDate={disableDate}
                        defaultPickerValue={minDate}
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>

                      <InputBox.Select
                        name="gender"
                        label={<>Gender {genderCheck != "1" && <em>*</em>}</>}
                        placeholder=''
                        
                        className={"ecn-input profile-input " + (genderCheck === "1" ? '' : 'active')}
                        allowClear={true}
                        rules={genderCheck === "1" ? [] : rules.gender()}
                        disabled={genderCheck === "1" ? true : false}
                        options={{
                          list: gender,
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />
                      {/* <div className="d-flex justify-space-between align-items-center lableWithCheckBox">
                        <InputBox.Checkbox
                          noStyle
                          name="decline_to_answer_gender"
                          options={{
                            list: [
                              {
                                id: 1,
                                name: "Decline to answer",
                              },
                            ],
                            valueKey: "id",
                            textKey: "name",
                          }}
                          onChange={(e: any) => {
                            setGenderCheck(
                              e[0] === "0" || e[0] === undefined ? "0" : "1"
                            );
                            if (Number(genderCheck) === 0) {
                              form.setFieldsValue({ gender: null });
                            }
                          }}
                        />
                      </div> */}
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>

                      <InputBox.Select
                        // placeholder="Ethnicity"
                        label={<>Ethnicity {EthnicityCheck != "1" && <em>*</em>}</>}
                        placeholder=''
                        className={"ecn-input profile-input " + (EthnicityCheck === "1" ? '' : 'active')}

                        onFocus={getRaceList}
                        name="race_id"
                        allowClear={true}
                        rules={EthnicityCheck === "1" ? [] : rules.race()}
                        disabled={EthnicityCheck === "1" ? true : false}
                        options={{
                          list: raceData,
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />
                      {/* <div className="d-flex justify-space-between align-items-center lableWithCheckBox">
                        // {/* <label className="profileLable">Ethnicity</label> 
                        <InputBox.Checkbox
                          noStyle
                          name="decline_to_answer_race_id"
                          options={{
                            list: [
                              {
                                id: 1,
                                name: "Decline to answer",
                              },
                            ],
                            valueKey: "id",
                            textKey: "name",
                          }}
                          onChange={(e: any) => {
                            setEthnicityCheck(
                              e[0] === "0" || e[0] === undefined ? "0" : "1"
                            );
                            if (Number(EthnicityCheck) === 0) {
                              form.setFieldsValue({ race_id: null });
                            }
                          }}
                        />
                      </div> */}
                    </Col>
                  </Row>
                  <div className="profile-section-header">Your Background</div>
                  <Row gutter={[0, 24]}>
                    {userDetail?.company && userDetail?.company?.id != undefined &&
                      <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                        <InputBox.Text
                          label={<>Customer </>}
                          placeholder=''
                          className={"ecn-input profile-input active"}
                          value={userDetail?.company?.company_name}
                          disabled={true}
                        />
                      </Col>
                    }
                    {userDetail?.industry && userDetail?.industry?.id != undefined &&
                      <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                        <InputBox.Text
                          label={<>Industry </>}
                          placeholder=''
                          className={"ecn-input profile-input active"}
                          value={userDetail?.industry?.industry_name}
                          disabled={true}
                        />
                      </Col>
                    }
                    <InputBox.Text hidden name="location" />
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                      <InputBox.Select
                        allowClear
                        name="location"
                        rules={rules.zipCode()}
                        // label="Location (Zip Code)"
                        // placeholder="Search Location (Zip Code)"

                        label={<>Location (Zip Code) <em>*</em></>}
                        placeholder=''
                        className="ecn-input profile-input active"

                        onKeyUp={() => {
                          setTimeout(() => {
                            setIsPlacePredictionsLoading(false);
                          }, 2000);
                        }}
                        showSearch
                        onSearch={(value: any) => {
                          setPinCode(value);
                        }}
                        notFoundContent={
                          isPlacePredictionsLoading ? (
                            <Spin size="default" />
                          ) : (
                            "No Place Found."
                          )
                        }
                        optionFilterProp="children"
                        onSelect={(e) => {
                          setSelectOk(e);
                        }}
                        onClear={() => (
                          setList([]),
                          setStateDetail([]),
                          setSelectOk(0),
                          form.setFieldsValue({ city: '' }),
                          setLatLng({
                            lat: 0,
                            lng: 0,
                          })
                        )}
                      options={{
                        list: list,
                      }}
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>
                      <InputBox.Text
                        name="city"
                        label={<>City </>}
                        placeholder=''
                        className="ecn-input profile-input active"
                        disabled
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>

                      <InputBox.Select
                        name="house_hold_income"
                        label={<>Household Income {houseHoldCheck != "1" && <em>*</em>}</>}
                        placeholder=''
                        className={"ecn-input profile-input " + (houseHoldCheck === "1" ? '' : 'active')}

                        allowClear={true}
                        rules={houseHoldCheck === "1" ? [] : rules.veteran_status()}
                        disabled={houseHoldCheck === "1" ? true : false}
                        options={{
                          list: houseHold,
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />
                      {/* <div className="d-flex justify-space-between align-items-center lableWithCheckBox">
                        <InputBox.Checkbox
                          noStyle
                          name="decline_to_answer_household_income"
                          options={{
                            list: [
                              {
                                id: 1,
                                name: "Decline to answer",
                              },
                            ],
                            valueKey: "id",
                            textKey: "name",
                          }}
                          onChange={(e: any) => {
                            setHouseHoldCheck(
                              e[0] === "0" || e[0] === undefined ? "0" : "1"
                            );
                            if (Number(houseHoldCheck) === 0) {
                              form.setFieldsValue({ house_hold_income: null });
                            }
                          }}
                        />
                      </div> */}
                    </Col>

                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>

                      <InputBox.Select
                        // + (willing_to_relocate_value == null ? '' : 'active')
                        label={<>Willing to Relocate? </>}
                        placeholder=''
                        className={"ecn-input profile-input active"}
                        name="willing_to_relocate"
                        rules={rules.willing_to_relocate()}
                        options={{
                          list: [{ id: 1, name: 'Yes' }, { id: 0, name: 'No' }],
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>

                      <InputBox.Select
                        // placeholder="Disabilities"
                        label={<>Disability Status {disabilitiesCheck != "1" && <em>*</em>}</>}
                        placeholder=''
                        className={"ecn-input profile-input " + (disabilitiesCheck === "1" ? '' : 'active')}

                        name="disabilities"
                        rules={disabilitiesCheck === "1" ? [] : rules.disabilities()}
                        allowClear={true}
                        disabled={disabilitiesCheck === "1" ? true : false}
                        options={{
                          list: disabilityStatus,
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />
                      {/* <div className="d-flex justify-space-between align-items-center lableWithCheckBox">
                        <InputBox.Checkbox
                          noStyle
                          name="decline_to_answer_disabilities"
                          options={{
                            list: [
                              {
                                id: 1,
                                name: "Decline to answer",
                              },
                            ],
                            valueKey: "id",
                            textKey: "name",
                          }}
                          onChange={(e: any) => {
                            setDisabilitiesCheck(
                              e[0] === "0" || e[0] === undefined ? "0" : "1"
                            );
                            if (Number(disabilitiesCheck) === 0) {
                              form.setFieldsValue({ disabilities: null });
                            }
                          }}
                        />
                      </div> */}
                    </Col>
                    <Col sm={12} xs={24} md={12} xl={6} xxl={6}>

                      <InputBox.Select
                        name="veteran_status"
                        // placeholder="Military Status"
                        label={<>Military Status {veteranStatusCheck != "1" && <em>*</em>}</>}
                        placeholder=''
                        className={"ecn-input profile-input " + (veteranStatusCheck === "1" ? '' : 'active')}
                        allowClear={true}
                        rules={
                          veteranStatusCheck === "1" ? [] : rules.veteran_status()
                        }
                        disabled={veteranStatusCheck === "1" ? true : false}
                        onFocus={getVeteranList}
                        options={{
                          list: veteranData,
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />
                      {/* <div className="d-flex justify-space-between align-items-center lableWithCheckBox">
                        <InputBox.Checkbox
                          noStyle
                          name="decline_to_answer_veteran_status"
                          options={{
                            list: [
                              {
                                id: 1,
                                name: "Decline to answer",
                              },
                            ],
                            valueKey: "id",
                            textKey: "name",
                          }}
                          onChange={(e: any) => {
                            setVeteranStatusCheck(
                              e[0] === "0" || e[0] === undefined ? "0" : "1"
                            );
                            if (Number(veteranStatusCheck) === 0) {
                              form.setFieldsValue({ veteran_status: null });
                            }
                          }}
                        />
                      </div> */}

                    </Col>
                  </Row>
                  <div className="profile-section-header">Education & Experience</div>
                  <Row gutter={[24, 24]}>





                    <Col sm={24} xs={24} md={24} xl={24} xxl={24}>
                      <label htmlFor="education_level">What is the highest level of education you’ve completed? <em>*</em></label>
                      <InputBox.Select
                        name="education_level"
                        // label={<>What is the highest level of education you’ve completed? <em>*</em></>}
                        placeholder=''
                        className={"ecn-input profile-input " + (education_level_value == null ? '' : 'active')}
                        allowClear={true}
                        rules={rules.education_level()}
                        options={{
                          list: educationLevel,
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />

                    </Col>
                    <Col sm={24} xs={24} md={24} xl={24} xxl={24}>
                      <label htmlFor="year_of_experience">How many years of work or hands-on experience do you have in your main field or industry?  <em>*</em></label>

                      <InputBox.Select
                        name="year_of_experience"
                        // label={<>How many years of work or hands-on experience do you have in your main field or industry?  <em>*</em></>}
                        placeholder=''
                        className={"ecn-input profile-input " + (year_of_experience == null ? '' : 'active')}
                        allowClear={true}
                        rules={rules.year_of_experience()}
                        // onChange={()=>form.getFieldValue('yearsOfExperience')}
                        options={{
                          list: yearsOfExperience,
                          valueKey: "id",
                          textKey: "name",
                        }}
                      />

                    </Col>
                  </Row>

                </div>

                <div className="profile-btn-row">
                  <Button className="profile-save-btn" loading={save} htmlType="submit">Save changes</Button>
                </div>
              </FormBox>

            </div>
          )}
          {activeTab === "Change Password" && (
            <div className="profile-card-container">
              <div className="profile-section-common">
                <ProfileChangePassword />
              </div>

            </div>
          )}
          {activeTab === "Account Settings" &&
            (isMobile ? (
              <div className="profile-card-container">
                <div className="account-settings-card">
                  <div className="account-settings-header">
                    Delete your account
                  </div>
                  <div className="account-settings-desc">
                    By deleting your account, you will lose all your saved results
                  </div>
                  <div className="account-settings-btn-row ">
                    <Button
                      style={{ width: "100%" }}
                      className="account-settings-delete-btn"
                      onClick={openDeleteAccountModal}
                    >
                      Delete account
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="profile-card-container">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div className="account-settings-header">
                      Delete your account
                    </div>
                    <div className="account-settings-desc">
                      By deleting your account, you will lose all your saved
                      results
                    </div>
                  </div>
                  <div className="account-settings-btn-row">
                    <Button
                      className="account-settings-delete-btn"
                      onClick={openDeleteAccountModal}
                    >
                      Delete account
                    </Button>
                  </div>
                </div>
              </div>
            ))
          }

          {activeTab === "Account Settings" &&
            <>
              <div className="profile-card-container" style={{ marginTop: '2rem' }}>
                <Flex justify="space-between">
                  <div>
                    <div className="account-settings-header">
                      Remember device
                      <span className="infoCircle" style={{ marginLeft: '1rem' }}>
                        <Tooltip
                          placement="top"
                          title={"Keep me signed in for 60 days."}
                          overlayClassName="examTooltip"
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      </span>
                    </div>
                    <div className="account-settings-desc">
                      To remember this device in the future, please log in again.
                    </div>
                  </div>
                  <Flex align="center">

                    <Switch value={rememberToggle} disabled={!rememberToggle} onChange={(e) => onRememberToggleChange(e)} />

                  </Flex>
                  {/* <div className="account-settings-btn-row">

                  </div> */}
                </Flex>
              </div>
            </>}
          {activeTab === "Subscription" && (
            <div className="subscription-tab-container-section">
              {/* Subscription Card */}
              <div className="subscription-section-card subscription-card">
                <div className="subscription-card-header-row">
                  <div className="subscription-card-title-group">
                    <div className="subscription-header-row-flex">
                      <div className="subscription-card-title">Subscription</div>
                      <div className="subscription-header-actions">
                        {/* <Button className="subscription-btn-green">Cancel Automatic Renewal</Button> */}

                      </div>
                    </div>



                    <span className={`subscription-card-link ${get_current_access == 1 ? 'has-access' : 'is-free'}`}>{get_current_access == 1 ? 'Starter access' : 'Free Trial'}</span>



                  </div>
                </div>
              </div>
              {userDetail?.purchased == 0 && <div className="subscription-section-card ">

                <div className="subscription-card-header-row">
                  <div className="subscription-card-title-group">

                    <Row >
                      <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                        <div className="subscription-card-title">Do you have an access code?</div>

                      </Col>
                      <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                        <Flex justify={screens.sm ? "flex-end" : screens.xs ? "flex-start" : ""} >
                          <div>
                            <span className="subscription-payment-title" style={{ margin: '0 1rem' }}>{hasAccessCodeStatus ? 'Yes' : "No"}</span>
                            <Switch value={hasAccessCodeStatus} onChange={(e) => {
                              dispatch(setHasAccessCodeStatus(!hasAccessCodeStatus));
                            }} />
                          </div>
                        </Flex>
                      </Col>

                    </Row>
                    {/* <div className="subscription-header-row-flex">
                      <div className="subscription-header-actions">
                      </div>
                    </div> */}



                    {hasAccessCodeStatus &&
                      <>
                        <Divider />

                        <FormBox
                          layout="vertical"
                          autoComplete="off"
                          form={accessform}
                          id="userAccessUpdate"
                          onFinish={userAccessCodeChange}
                          className="userProfile access-form"
                          style={{ marginTop: '2rem' }}
                        >
                          <Row >
                            <Col sm={18} xs={24} md={18} xl={12} xxl={12}>
                              <InputBox.Text
                                name={"access_code"}
                                label={<>Access Code <em>*</em></>}
                                placeholder=''
                                className={'ecn-input '}
                                rules={rules.access_code()}
                              />
                            </Col>
                            <Col sm={6} xs={24} md={6} xl={12} xxl={12}>
                              <Flex justify={screens.sm ? "flex-end" : screens.xs ? "flex-start" : ""} >
                                <Button htmlType="submit" form="userAccessUpdate" className="subscription-btn-outline">Upgrade</Button>
                              </Flex>
                            </Col>
                          </Row>
                        </FormBox>
                      </>

                    }
                  </div>
                </div>




              </div>}
              {/* Billing Information Card */}
              {billingModalVisible && (
                <Modal
                  open={billingModalVisible}
                  onCancel={() => setBillingModalVisible(false)}
                  footer={null}
                  className="billing-history-modal"
                  centered
                  width={window.innerWidth > 700 ? '85%' : "100%"}
                  closeIcon={null}
                >

                  <div className="billing-history-modal-header">
                    <span>Billing History</span>
                    <span
                      className="billing-history-modal-close"
                      onClick={() => setBillingModalVisible(false)}
                      tabIndex={0}
                      role="button"
                    >
                      <span style={{ fontSize: 24, color: '#222', cursor: 'pointer' }}>×</span>
                    </span>
                  </div>
                  <div className="billing-history-table-wrapper">
                    <table className="billing-history-table">
                      <thead>
                        <tr>
                          <th>Subscription</th>
                          <th>Invoice</th>
                          <th>Billing Date</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {billingHistory.map((row, idx) => (
                          <tr key={row.invoice} className={idx % 2 == 0 ? 'billing-history-row-alt' : ''}>
                            <td><b>{row.plan}</b></td>
                            <td>{row.invoice}</td>
                            <td>{row.date}</td>
                            <td>{row.amount}</td>
                            <td>
                              {row.status === 'Paid' ? (
                                <span className="billing-status billing-status-paid">Paid</span>
                              ) : (
                                <span className="billing-status billing-status-cancelled">Cancelled</span>
                              )}
                            </td>
                            <td>
                              <Button className="billing-download-btn" icon={<DownloadOutlined />}>Download</Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </Modal>
              )}
            </div>
          )}

        </>
      </div>
      <Modal
        title={
          <div className="delete-modal-title-row">
            <span className="delete-modal-title">Delete account</span>
            <span
              className="delete-modal-close-btn"
              onClick={closeDeleteAccountModal}
              tabIndex={0}
              role="button"
            >
              <CloseOutlined style={{ fontSize: 24, color: "#222" }} />
            </span>
          </div>
        }
        open={deleteAccoutnModal}
        onCancel={closeDeleteAccountModal}
        footer={
          <Button
            className="delete-modal-confirm-btn"
            htmlType="button"
            disabled={!confirmDeleteChecked}
            onClick={() => {
              if (confirmDeleteChecked) deleteAccountBtn();
            }}
          >
            Confirm deletion
          </Button>
          // <Row gutter={[15, 15]}>
          //   <Col md={24}>
          //   </Col>
          // </Row>
        }
        className="delete-account-modal"
        centered
        width={540}
        closeIcon={null}
      >
        <div className="delete-modal-section">
          <div className="delete-modal-question">
            <b>Are you sure you want to delete your account?</b>
          </div>

          <Checkbox
            checked={confirmDeleteChecked}
            onChange={(e) => setConfirmDeleteChecked(e.target.checked)}
            className="delete-modal-checkbox"
          >
            I understand the consequences
          </Checkbox>
        </div>

      </Modal>

      {/* const [eduExpConfirmModal, setEduExpConfirmModal] = useState<boolean>(false); */}


      <CommonModal
        title={'Profile Update Notice'}
        open={eduExpConfirmModal}
        onCancel={() => { setEduExpConfirmModal(false) }}
        footer={
          <Row gutter={[15, 15]}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Button
                key="2"
                htmlType="button"
                className='common_button green_border_common_btn common_fill_button'
                onClick={() => userProfileUpdate(true)}
              >
                Yes
              </Button>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Button
                key="1"
                htmlType="button"
                className='common_button green_border_common_btn'
                onClick={() => {
                  form.setFieldValue('year_of_experience', (userDetail?.year_of_experience ? Number(userDetail?.year_of_experience) : null));
                  form.setFieldValue('education_level', (userDetail?.education_level ? Number(userDetail?.education_level) : null));
                  setEduExpConfirmModal(false);
                }}
              >
                No
              </Button>
            </Col>
          </Row>

        }
        className="startExamModal"
      >
        {/* <h3 style={{ fontSize: '2.5rem' }}>Are you sure?</h3> */}
        {/* <span>Changing your education or experience will reset your current exam progress.</span> */}
        <p>You've made changes to your experience and/or education level. This will affect your career assessment results.</p>
        <p>You currently have an <b>[Interest Discovery/Skill Portrait]</b> in progress.</p>
        <p>If you save these changes, your assessment will be <b>reset</b> to ensure results accurately reflect your updated profile.</p>
        <p><b>Do you want to proceed?</b></p>
      </CommonModal>
    </div>
  );
};

export default UserProfile;
